import { useState } from 'react';
import { useIsoLayoutEffect } from '../elements/render/useIsoLayoutEffect';

// The note a shopper writes in the cart, kept for the tab's life so a reload or a checkout on its own page
// never loses what was typed. Storage may be blocked or full; the note then lives only in memory.

// Reads the stored note, or nothing where storage is blocked.
const stored = (key: string): string => {
  try { return window.sessionStorage.getItem(key) ?? ''; } catch { return ''; }
};

// Holds the cart's order note for this store, kept in the tab's storage as it is typed. It starts empty, as a page drawn
// on the server shows it, and takes the stored note before the first paint.
export function useOrderNote(storeSlug: string): [string, (note: string) => void] {
  const key = `xshop:order-note:${storeSlug}`;
  const [note, setNote] = useState('');
  useIsoLayoutEffect(() => { setNote(stored(key)); }, [key]);
  const write = (next: string) => {
    setNote(next);
    try { if (next) window.sessionStorage.setItem(key, next); else window.sessionStorage.removeItem(key); } catch { /* storage blocked: memory only */ }
  };
  return [note, write];
}
